export const ENDPOINTS = Object.freeze({
  GH_LOGIN: 'api/gh-login',
  GH_LOGOUT: 'api/gh-logout',
  USER: 'api/user',
  RUNNERS: 'api/runner',
  REPOSITORIES: 'api/repos',
  TEAMS: 'api/team',
  API_TOKENS: 'api/token',
  EVENTS: 'api/events',
  ANALYTICS: 'api/analytics',
  SUBSCRIPTION: 'api/subscription',
  CLOUD_AWS: 'api/aws-connect',
  CLOUD_GCP: 'api/gcp-connect',
  CLOUD_AZURE: 'api/azure-connect',
  CLOUD_ORACLE: 'api/oracle-connect',
  CLOUD_OPENSTACK: 'api/openstack-connect',
  CLOUD_VASTAI: 'api/vastai-connect',
  ONPREM_AGENTS: 'api/onprem/agents',
  GH_SEARCH: 'api/github/search',
});
